import React from 'react';
import {Scale, Phone, Mail, MapPin} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 text-white py-16 border-t border-cyan-500/30 relative">
      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/5521996853559?text=Olá, preciso de orientação sobre direito do consumidor"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 bg-gradient-to-br from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white p-5 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-110 z-50 animate-bounce"
        aria-label="Falar no WhatsApp"
      >
        <svg className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z" />
        </svg>
      </a>

      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gradient-to-br from-cyan-500 to-cyan-600 p-2 rounded-lg shadow-lg">
                <Scale className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="font-bold text-xl">Angélica Rabello</h3>
                <p className="text-sm text-gray-300">Advocacia</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Escritório de advocacia especializado em Direito do Consumidor, com mais de 15 anos de experiência defendendo seus direitos.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4 text-blue-400">Links Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="#sobre" className="text-gray-300 hover:text-blue-400 transition-colors">Sobre</a></li>
              <li><a href="#servicos" className="text-gray-300 hover:text-blue-400 transition-colors">Serviços</a></li>
              <li><a href="#faq" className="text-gray-300 hover:text-blue-400 transition-colors">FAQ</a></li>
              <li><a href="#contato" className="text-gray-300 hover:text-blue-400 transition-colors">Contato</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4 text-blue-400">Contato</h4>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <a href="tel:+5521996853559" className="hover:text-blue-400 transition-colors">
                  (21) 99685-3559
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:atendimento@angelicarabelloadvocacia.com.br" className="hover:text-blue-400 transition-colors break-all">
                  atendimento@angelicarabelloadvocacia.com.br
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p>Rio de Janeiro - RJ</p>
                  <p className="text-xs text-gray-400">Atendimento presencial e online</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cyan-500/30 pt-8 text-center text-gray-300 text-sm">
          <p>&copy; {new Date().getFullYear()} Angélica Rabello Advocacia - Todos os direitos reservados</p>
          <p className="mt-2 text-blue-400 font-semibold">OAB/RJ 245.846 • Dra. Angélica Rabello Turino</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
